import * as React from "react"

const SvgRules = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M15 20.429a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.286h1.6l-2.475-2.475a.93.93 0 0 1-.287-.713 1.02 1.02 0 0 1 .312-.712q.3-.3.713-.3.412 0 .712.3L18 16.979v-1.55q0-.426.288-.713A.97.97 0 0 1 19 14.43q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712a.97.97 0 0 1-.712.288h-4Zm-10.7-.3a.95.95 0 0 1-.275-.7q0-.426.275-.7l12.3-12.3H15a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 5.43a.97.97 0 0 1 .287-.713A.97.97 0 0 1 15 4.43h4q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.712-.288A.97.97 0 0 1 18 9.43v-1.6L5.7 20.13a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275Zm-.025-14a.95.95 0 0 1-.275-.7q0-.426.275-.7a.93.93 0 0 1 .688-.275q.411 0 .712.275l4.2 4.175a.97.97 0 0 1 .287.687.93.93 0 0 1-.287.713.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275z" />
  </svg>
)
export default SvgRules
